// extracted by mini-css-extract-plugin
export var avatarContainer = "_5v-1";
export var largeAvatarContainer = "_5v-2";
export var smallAvatarContainer = "_5v-0";